// Services.styles.js
const ServicesStyles = {
  heroSection: {
    height: '60vh',
    backgroundImage: `url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    textAlign: 'center',
    padding: '2rem',
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.6)', // Darker overlay for contrast
      zIndex: 1,
    },
    '& > *': {
      position: 'relative',
      zIndex: 2,
    },
  },
  heroTitle: {
    fontWeight: 'bold',
    marginBottom: '1rem',
    fontSize: '3rem',
    color: '#81c241', // Lime green for title
  },
  heroSubtitle: {
    fontSize: '1.5rem',
    marginBottom: '2rem',
    maxWidth: '600px',
    color: '#E0E0E0', // Light grey for readability
  },
  heroButton: {
    backgroundColor: '#81c241', // Green accent
    color: '#fff',
    padding: '0.75rem 2rem',
    fontSize: '1rem',
    '&:hover': {
      backgroundColor: '#6aa832', // Darker green on hover
    },
  },
  subscriptionSection: {
    padding: '60px 20px',
    backgroundColor: '#333333', // Dark black background
    textAlign: 'center',
  },
  sectionTitle: {
    fontWeight: 'bold',
    marginBottom: '2.5rem',
    color: '#81c241', // Lime green for section titles
  },
  subscriptionText: {
    maxWidth: '800px',
    margin: '0 auto 2rem auto',
    color: '#666666', // Medium grey for text
    fontSize: '1.1rem',
  },
  pricingCard: {
    padding: '2rem',
    textAlign: 'center',
    borderRadius: '12px',
    boxShadow: '0px 6px 15px rgba(0, 0, 0, 0.3)', // Stronger shadow for dark theme
    backgroundColor: '#555555', // Dark grey for cards
    transition: 'transform 0.3s',
    '&:hover': {
      transform: 'translateY(-5px)',
    },
  },
  pricingTitle: {
    fontWeight: 'bold',
    marginBottom: '1rem',
    color: '#81c241', // Green for pricing titles
  },
  pricingPrice: {
    fontWeight: 'bold',
    color: '#81c241', // Lime green for price
    marginBottom: '1rem',
  },
  pricingDetails: {
    color: '#666666', // Medium grey for details
  },
  featuresSection: {
    padding: '60px 20px',
    backgroundColor: '#000000', // Slightly darker black for contrast
  },
  featureCard: {
    padding: '2rem',
    textAlign: 'center',
    borderRadius: '12px',
    boxShadow: '0px 6px 15px rgba(0, 0, 0, 0.3)',
    backgroundColor: '#555555', // Dark grey for cards
    transition: 'transform 0.3s',
    '&:hover': {
      transform: 'translateY(-5px)',
    },
  },
  featureTitle: {
    fontWeight: 'bold',
    marginBottom: '1rem',
    color: '#81c241', // Green for feature titles
  },
  featureText: {
    color: '#666666', // Medium grey for text
  },
  benefitsSection: {
    padding: '60px 20px',
    backgroundColor: '#333333', // Dark black background
  },
  benefitCard: {
    padding: '2rem',
    textAlign: 'center',
    borderRadius: '12px',
    boxShadow: '0px 6px 15px rgba(0, 0, 0, 0.3)',
    backgroundColor: '#555555', // Dark grey for cards
    transition: 'transform 0.3s',
    '&:hover': {
      transform: 'translateY(-5px)',
    },
  },
  benefitTitle: {
    fontWeight: 'bold',
    marginBottom: '1rem',
    color: '#81c241', // Green for benefit titles
  },
  benefitText: {
    color: '#666666', // Medium grey for text
  },
};

export default ServicesStyles;